// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5ccb5df2","160":"b1cde28e","208":"4f81bed6","293":"5bea5790","453":"466b5410","516":"e3689263","519":"e963afb9","917":"5c9affee","946":"496fe544"}[chunkId] + ".chunk.js";
};